/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';

import IconComponent from 'ui/src/components/Icon';
import twMerge from 'utilities/src/twMerge';
import ga4 from 'tracking/src/ga4';
import MobileMenu from './MobileMenu';

import useHeader from '../header/hooks/useHeader';
import { MobileMenuProps } from './_props';

function MobileHeader({ menuItems }: MobileMenuProps) {
  const { isMobileMenuOpen, toggleMobileMenu, toggleMobileMenuActiveItem } = useHeader();

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    if (isMobileMenuOpen) {
      timeoutId = setTimeout(() => {
        ga4.assignEvent(process.env.NEXT_PUBLIC_GA4, 'new_topnav_viewed', {
          type: 'navbar_menu_event',
          url: document.URL,
        });
      }, 1000);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [isMobileMenuOpen]);

  const handleMenuClick = () => {
    toggleMobileMenu();
    if (isMobileMenuOpen) {
      toggleMobileMenuActiveItem('');
    }
  };

  return (
    <>
      <button type="button" className="mdL:hidden block" onClick={handleMenuClick} aria-label="toggle">
        <IconComponent
          iconName={isMobileMenuOpen ? 'Close' : 'Menu'}
          size="IconM"
          className={twMerge('bg-site-neutrals-900')}
        />
      </button>

      <MobileMenu menuItems={menuItems} />
    </>
  );
}

export default MobileHeader;
